export default "__VITE_ASSET__CtETy03M__"